import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const HeaderSocial = ({ clang }) => {
    return (
        <div className="header__social">
            <a href="https://www.facebook.com/Polska.Bibliografia.Literacka"
            target="blank"
            title={lang[clang].title.facebook}
            className="header__social-link">
                <span className="header__social-img--fb"></span>
            </a>
        </div>
    );
};

HeaderSocial.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(HeaderSocial);



// WEBPACK FOOTER //
// ./src/components/header/HeaderSocial.js